import { Component } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenuTrigger, MatMenu } from '@angular/material/menu';

@Component({
  selector: 'app-table-actions-button',
  templateUrl: './table-actions-button.component.html',
  imports: [MatIconButton, MatMenuTrigger, MatIcon, MatMenu],
})
export class TableActionsButtonComponent {}
